import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.title',
		defaultMessage: 'Fields',
		description: 'Title for the list of available fields in the sidebar',
	},
	whatIsThisContent: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.what-is-this-content',
		defaultMessage:
			"Fields capture and display the information people need to carry out a project's work",
		description: 'Explanation text inside tooltip',
	},
	moreInformationAboutTheFieldsButtonText: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.more-information-about-the-fields-button-text',
		defaultMessage: 'More information about the fields',
		description: 'Button that shows more details about available items',
	},
	emptyStateTitle: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.empty-state-title',
		defaultMessage: 'Drag fields here to remove them',
		description: 'Title displayed when there are no available fields in the list',
	},
	emptyStateMessage: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.empty-state-message',
		defaultMessage:
			'Fields in this area aren’t shown in the issue view for this request type. You can drag the fields back to the left to show them.',
		description: 'Message displayed when there are no available fields in the list ',
	},
	emptyStateMessageIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.empty-state-message-issue-term-refresh',
		defaultMessage:
			'Fields in this area aren’t shown in the work item view for this request type. You can drag the fields back to the left to show them.',
		description: 'Message displayed when there are no available fields in the list ',
	},
	notFoundStateTitle: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.not-found-state-title',
		defaultMessage: 'We couldn’t find what you’re looking for.',
		description: 'Title displayed when there are no matching fields in the list',
	},
	notFoundStateTitleWithProjectName: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.not-found-state-title-with-project-name',
		defaultMessage: 'No fields found in "{projectName}" match that search',
		description:
			'Title (including project name) displayed when there are no matching fields in the list',
	},
	notFoundStateMessage: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.not-found-state-message',
		defaultMessage: 'Try searching for something else or create a new field.',
		description: 'Message displayed when there are no matching fields in the list ',
	},
	notFoundStateMessageWithFieldsPage: {
		id: 'project-settings-product-features-jsw-tmp.sidebar.not-found-state-message-with-fields-page',
		defaultMessage: 'Add fields to your project on the fields page to use it here.',
		description: 'Message displayed when there are no matching fields in the list ',
	},
});

export const fieldGroupMessages = defineMessages({
	suggestedGroupContent: {
		id: 'project-settings-product-features-jsm-tmp.sidebar.suggested-group-content',
		defaultMessage: 'These fields were recently created, or are currently used in this project.',
		description: 'Explanation text for suggested fields inside tooltip',
	},
});

export default messages;
